import React, { useContext, useEffect, useState } from "react";
import { Box, Button, Grid, IconButton, Tooltip } from "@mui/material";
import { Stack } from "@mui/system";
// import signature from "../../../assets/signature.png";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import Checkbox from "@mui/material/Checkbox";
import { authHttp } from "../../services/utility";
import { apisPath, paths } from "../../../utils/path";
import { AuthContext } from "../../../context/AuthContext";
import { fDate } from "../../../utils/formatTime";
import PrintIcon from "@mui/icons-material/Print";
import { decrypt, encrypt } from "../../../utils/encryptDecrypt";
// import { abledType } from "../../../utils/helpers";
import HeaderLogoImage from "../../../assets/pdf-logo.png";
import { abledType, appPrefix } from "../../../utils/helpers";
import CloseIcon from "@mui/icons-material/Close";
import "../../../styles/Layout/Admin_Styles/_CandidateInfoModal.scss";
import PersonalDetails from "./PersonalDetails";
import EducationDetailsTable from "./EducationDetailsTable";
import NoSignatureImg from "../../../assets/no-signature.png";
import { useLocation, useNavigate } from "react-router-dom";

export default function CandidateInfoModal(_props) {
  const { selectedId } = _props;

  const { state } = useLocation();
  const navigate = useNavigate();
  const [isFeeExempted, setIsFeeExempted] = useState(false);
  const [candidateData, setCandidateData] = useState({});
  const { setIsLoading, setAlertState } = useContext(AuthContext);

  const [pageState, setPageState] = useState(0);
  const [claimedMsg, setClaimedMsg] = useState("");

  useEffect(() => {
    if (state) {
      setIsLoading(true);
      authHttp
        .post(apisPath?.admin?.viewApplicationDetail, {
          application_no: state.replace(appPrefix, ""),
        })
        .then((res) => {
          // console.log()
          const idProofNo = res?.data?.data?.id_proof_no
            ? decrypt(res?.data?.data?.id_proof_no)
            : "";
          if (idProofNo) {
            let tempidProofNo = `${idProofNo.slice(0, 2)}`;
            for (let i = 0; i < idProofNo.length - 4; i++) {
              tempidProofNo += "X";
            }
            tempidProofNo += `${idProofNo.slice(idProofNo.length - 2)}`;
            tempidProofNo = encrypt(tempidProofNo);
            setCandidateData({
              ...res?.data?.data,
              id_proof_no: tempidProofNo,
            });
          } else {
            setCandidateData(res?.data?.data);
          }
          // console.log()
          setIsFeeExempted(
            parseInt(
              res?.data?.data?.total_fee +
              (Number(
                res?.data?.data
                  ?.permanent_resident_uttarakhand_covered_by_govt_order
              ) === 1
                ? 0
                : 22.3)
            ) === 0
          );
          const tempType = abledType.find(
            (type) => type?.name === res?.data?.data?.differently_abled_type
          );
          let msg = "";
          msg = res?.data?.data?.category;
          msg +=
            Number(res?.data?.data?.is_differently_abled) === 1
              ? `/PH(${tempType?.short_code})`
              : "";
          msg +=
            Number(res?.data?.data?.is_exserviceman) === 1 &&
              Number(res?.data?.data?.exservicemen_availed_benefits) === 0
              ? "/Ex-Servicemen"
              : "";
          msg +=
            Number(res?.data?.data?.dff) === 1
              ? "/Dependent of Freedom Fighter (DFF)"
              : "";
          msg +=
            Number(
              res?.data?.data
                ?.permanent_resident_uttarakhand_covered_by_govt_order
            ) === 1
              ? "/Uttarakhand Orphan"
              : "";
          msg +=
            Number(res?.data?.data?.is_uttarakhand_female) === 1
              ? "/Uttarakhand Female"
              : "";
          setClaimedMsg(msg);
          // setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
          setAlertState((prev) => ({
            ...prev,
            open: true,
            title: err?.response?.data?.msg,
            btnTxt: "CLOSE",
            status: "fail",
            isSessionExpire: err?.response?.status === 401,
            sessionType: "admin",
          }));
        });
    } else {
      navigate(
        `${paths?.admin?.commonPoint}/${paths?.admin?.user?.commonPoint}/${paths?.admin?.user?.candidates}`
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedId]);

  const handlePrint = (id) => {
    const element = document.getElementById(id);
    if (element) {
      window.print(element);
    }
  };

  return (
    <Box className="candidate-info" id="candidate-data">
      {/* <div className="candidate-info--header">
        <Container maxWidth="xl">
          <h2>
            Basic Information - (
            <span className="text-danger">
              <strong>*</strong>
            </span>
            ) Fields are mandatory / सामान्य जानकारी-(
            <span className="text-danger">
              <strong>*</strong>
            </span>
            ) मार्क्स फील्ड अनिवार्य है
          </h2>
        </Container>
      </div> */}

      <div className="candidate-info--grid">
        {pageState === 0 && (
          <Grid container>
            {/* <Grid item lg={3} md={3} sm={12} xs={12}>
              <div className="candidate-info--sidebar">
                <ul className="candidate-info--menu">
                  <li className="candidate-info--item">Fee Details</li>

                  <li className="candidate-info--item">Personal Information</li>
                  <li className="candidate-info--item">Nationality</li>
                  <li className="candidate-info--item">
                    Category / Sub Category Reservation Details
                  </li>
                  <li className="candidate-info--item">Present Address</li>
                  <li className="candidate-info--item">Permanent Address</li>
                  <li className="candidate-info--item">
                    Educational qualification Details
                  </li>

                  <li className="candidate-info--item">
                    Prefential Qualification
                  </li>

                  <li className="candidate-info--item">Other Details</li>
                  <li className="candidate-info--item">Declaration</li>
                </ul>
              </div>
            </Grid> */}
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <div className="print-logoNew">
                <div className="headerImg">
                  <img src={HeaderLogoImage} alt="ExamImg" height="500px" />
                </div>
              </div>
            </Grid>

            <Grid item lg={12} md={12} sm={12} xs={12}>
              <div className="candidate-info--head">
                <div className="candidate-info--header">
                  <h2>
                    {candidateData?.name ? decrypt(candidateData?.name) : "-"}
                  </h2>
                </div>
                <div className="candidate-info--button">
                  <Button
                    className="print-btn"
                    onClick={() => handlePrint("candidate-data")}
                    startIcon={<PrintIcon />}
                  >
                    Print
                  </Button>
                </div>
              </div>

              <div className="candidate-info--form">
                <div className="candidate-info--personaldetails">
                  <PersonalDetails
                    title="Personal Information"
                    isFinal={true}
                    candidateData={candidateData}
                  />
                </div>
                <div className="print-web">
                  <fieldset className="candidate-info--fieldset">
                    <legend className="candidate-info--legend">
                      Nationality
                    </legend>
                    <div className="print-web">
                      <Grid container spacing={1}>
                        <Grid item lg={3} md={3} sm={3} xs={6}>
                          <p className="candidate-info--nationalityText">
                            Nationality
                          </p>
                        </Grid>
                        <Grid item lg={9} md={9} sm={9} xs={6}>
                          <p className="candidate-info--nationalityText custom-rht2">
                            {candidateData?.nationality}
                          </p>
                        </Grid>
                      </Grid>
                    </div>
                    <div className="print-view">
                      <div className="print-details d-flex">
                        <div className="w-30">
                          <p className="candidate-info--nationalityText">
                            Nationality
                          </p>
                        </div>
                        <div className="w-70">
                          <p className="candidate-info--nationalityText">
                            {candidateData?.nationality}
                          </p>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </div>
                <fieldset className="candidate-info--fieldset categoryDetails">
                  <legend className="candidate-info--legend">
                    Required Eligibility
                  </legend>
                  {/* for web preview */}
                  <div className="print-web">
                    <Grid container spacing={3} alignItems={"center"}>
                      <Grid
                        item
                        lg={6}
                        md={6}
                        sm={6}
                        xs={6}
                        display="flex"
                        flexDirection={"row"}
                        alignItems="center"
                      >
                        <span
                          className="candidate-info--text"
                          style={{ marginRight: "10px" }}
                        >
                          1.
                        </span>
                        <p className="candidate-info--text">
                          Is your name registered in any District Employment
                          Office located in Uttarakhand State?
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--subText custom-rht2">
                          <p className="make-payment--subText">
                            {Number(
                              candidateData?.is_your_name_registered_any_district_employment
                            ) === 1
                              ? "Yes"
                              : "No"}
                          </p>
                        </p>
                      </Grid>
                      {Number(
                        candidateData?.is_your_name_registered_any_district_employment
                      ) === 1 && (
                          <>
                            <Grid
                              item
                              lg={6}
                              md={6}
                              sm={6}
                              xs={6}
                              display="flex"
                              flexDirection={"row"}
                              alignItems="center"
                            >
                              <span
                                className="candidate-info--text"
                                style={{ marginRight: "10px" }}
                              >
                                1(i).
                              </span>
                              <p className="candidate-info--text">
                                Employee Registration Number
                              </p>
                            </Grid>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                              <p className="candidate-info--subText">
                                {
                                  candidateData?.registered_any_district_employment_reg_no
                                }
                              </p>
                            </Grid>
                            <Grid
                              item
                              lg={6}
                              md={6}
                              sm={6}
                              xs={6}
                              display="flex"
                              flexDirection={"row"}
                              alignItems="center"
                            >
                              <span
                                className="candidate-info--text"
                                style={{ marginRight: "10px" }}
                              >
                                1.(ii)
                              </span>
                              <p className="candidate-info--text">
                                Employment Office District
                              </p>
                            </Grid>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                              <p className="candidate-info--subText">
                                {
                                  candidateData?.registered_any_district_employment_ofc_district
                                }
                              </p>
                            </Grid>{" "}
                            <Grid
                              item
                              lg={6}
                              md={6}
                              sm={6}
                              xs={6}
                              display="flex"
                              flexDirection={"row"}
                              alignItems="center"
                            >
                              <span
                                className="candidate-info--text"
                                style={{ marginRight: "10px" }}
                              >
                                1.(iii)
                              </span>
                              <p className="candidate-info--text">
                                Date of Registration
                              </p>
                            </Grid>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                              <p className="candidate-info--subText">
                                {fDate(
                                  candidateData?.registered_any_district_employment_date_of_registration,
                                  "dd/MM/yyyy"
                                )}
                              </p>
                            </Grid>{" "}
                            <Grid
                              item
                              lg={6}
                              md={6}
                              sm={6}
                              xs={6}
                              display="flex"
                              flexDirection={"row"}
                              alignItems="center"
                            >
                              <span
                                className="candidate-info--text"
                                style={{ marginRight: "10px" }}
                              >
                                1.(iv)
                              </span>
                              <p className="candidate-info--text">
                                Registration Date Valid Up to
                              </p>
                            </Grid>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                              <p className="candidate-info--subText">
                                {fDate(
                                  candidateData?.registered_any_district_employment_registration_date_valid_upto,
                                  "dd/MM/yyyy"
                                )}
                              </p>
                            </Grid>
                          </>
                        )}

                      <Grid
                        item
                        lg={6}
                        md={6}
                        sm={6}
                        xs={6}
                        display="flex"
                        flexDirection={"row"}
                        alignItems="center"
                      >
                        <span
                          className="candidate-info--text"
                          style={{ marginRight: "10px" }}
                        >
                          2.
                        </span>
                        <p className="candidate-info--text">
                          Are You Employed?
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--subText custom-rht2">
                          {Number(candidateData?.is_employed) === 1
                            ? "Yes"
                            : "No"}
                        </p>
                      </Grid>
                      {Number(candidateData?.is_employed) === 1 && (
                        <>
                          <Grid
                            item
                            lg={6}
                            md={6}
                            sm={6}
                            xs={6}
                            display="flex"
                            flexDirection={"row"}
                            alignItems="center"
                          >
                            <span
                              className="candidate-info--text"
                              style={{ marginRight: "10px" }}
                            >
                              2(i).
                            </span>
                            <p className="candidate-info--text">
                              Type of Organisation
                            </p>
                          </Grid>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--subText">
                              {candidateData?.employee_organization_type}
                            </p>
                          </Grid>
                          <Grid
                            item
                            lg={6}
                            md={6}
                            sm={6}
                            xs={6}
                            display="flex"
                            flexDirection={"row"}
                            alignItems="center"
                          >
                            <span
                              className="candidate-info--text"
                              style={{ marginRight: "10px" }}
                            >
                              2(ii).
                            </span>
                            <p className="candidate-info--text">
                              Date of Applying NOC
                            </p>
                          </Grid>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--subText">
                              {fDate(
                                candidateData?.employee_organization_noc,
                                "dd/MM/yyyy"
                              )}
                            </p>
                          </Grid>{" "}
                        </>
                      )}
                      <Grid
                        item
                        lg={6}
                        md={6}
                        sm={6}
                        xs={6}
                        display="flex"
                        flexDirection={"row"}
                        alignItems="center"
                      >
                        <span
                          className="candidate-info--text"
                          style={{ marginRight: "10px" }}
                        >
                          3.
                        </span>
                        <p className="candidate-info--text">
                          Have you passed your High School and Intermediate or
                          any other equivalent exam from any recognized
                          institution situated in the State of Uttarakhand?
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--subText custom-rht2">
                          <p className="make-payment--subText">
                            {Number(
                              candidateData?.is_passed_hs_s_school_any_other_exam
                            ) === 1
                              ? "Yes"
                              : "No"}
                          </p>
                        </p>
                      </Grid>
                      <Grid
                        item
                        lg={6}
                        md={6}
                        sm={6}
                        xs={6}
                        display="flex"
                        flexDirection={"row"}
                        alignItems="center"
                      >
                        <span
                          className="candidate-info--text"
                          style={{ marginRight: "10px" }}
                        >
                          4(i).
                        </span>
                        <p className="candidate-info--text">
                          Are you or your spouse or your parents regular
                          employees of the Armed Forces/Paramilitary Forces
                          serving in the state of Uttarakhand and whose services
                          cannot be transferred outside the state of
                          Uttarakhand?
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--subText custom-rht2">
                          <p className="make-payment--subText">
                            {Number(
                              candidateData?.is_your_spouse_parents_regular_employees_forces
                            ) === 1
                              ? "Yes"
                              : "No"}
                          </p>
                        </p>
                      </Grid>
                      <Grid
                        item
                        lg={6}
                        md={6}
                        sm={6}
                        xs={6}
                        display="flex"
                        flexDirection={"row"}
                        alignItems="center"
                      >
                        <span
                          className="candidate-info--text"
                          style={{ marginRight: "10px" }}
                        >
                          4(ii).
                        </span>
                        <p className="candidate-info--text">
                          Are you or your spouse or your parents regular
                          employees of the State Government/Semi Government
                          organisation serving on a regular basis in the state
                          of Uttarakhand and whose services cannot be
                          transferred outside the state of Uttarakhand?
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--subText custom-rht2">
                          <p className="make-payment--subText">
                            {Number(
                              candidateData?.is_your_spouse_parents_regular_employees_state_govt
                            ) === 1
                              ? "Yes"
                              : "No"}
                          </p>
                        </p>
                      </Grid>
                      <Grid
                        item
                        lg={6}
                        md={6}
                        sm={6}
                        xs={6}
                        display="flex"
                        flexDirection={"row"}
                        alignItems="center"
                      >
                        <span
                          className="candidate-info--text"
                          style={{ marginRight: "10px" }}
                        >
                          4(iii).
                        </span>
                        <p className="candidate-info--text">
                          Are you or your spouse or your parents regular
                          employees of Central Government organisation/ Central
                          Government Public Service Undertaking and are working
                          regularly in the State of Uttarakhand and whose
                          services cannot be transferred outside the State of
                          Uttarakhand
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--subText custom-rht2">
                          <p className="make-payment--subText">
                            {Number(
                              candidateData?.is_your_spouse_parents_regular_employees_central_govt
                            ) === 1
                              ? "Yes"
                              : "No"}
                          </p>
                        </p>
                      </Grid>
                      <Grid
                        item
                        lg={6}
                        md={6}
                        sm={6}
                        xs={6}
                        display="flex"
                        flexDirection={"row"}
                        alignItems="center"
                      >
                        <span
                          className="candidate-info--text"
                          style={{ marginRight: "10px" }}
                        >
                          5(i).
                        </span>
                        <p className="candidate-info--text">
                          Are you permanent resident of Uttarakhand but residing
                          outside Uttarakhand for livelihood/education purposes?
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--subText custom-rht2">
                          <p className="make-payment--subText">
                            {Number(
                              candidateData?.is_permanent_resident_of_uk_but_reside_uk
                            ) === 1
                              ? "Yes"
                              : "No"}
                          </p>
                        </p>
                      </Grid>
                      <Grid
                        item
                        lg={6}
                        md={6}
                        sm={6}
                        xs={6}
                        display="flex"
                        flexDirection={"row"}
                        alignItems="center"
                      >
                        <span
                          className="candidate-info--text"
                          style={{ marginRight: "10px" }}
                        >
                          5(ii).
                        </span>
                        <p className="candidate-info--text">
                          Is your spouse or your parents permanent residents of
                          Uttarakhand but are residing outside Uttarakhand for
                          livelihood/education purposes?
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--subText custom-rht2">
                          <p className="make-payment--subText">
                            {Number(
                              candidateData?.is_spouse_parents_permanent_resident_of_uk_but_reside_outside_uk
                            ) === 1
                              ? "Yes"
                              : "No"}
                          </p>
                        </p>
                      </Grid>
                    </Grid>
                  </div>
                  {/* for print preview */}
                  <div className="print-view">
                    <div className="print-details d-flex">
                      <div className="w-80 d-flex ">
                        <span
                          className="candidate-info--text"
                          style={{ marginRight: "10px" }}
                        >
                          1.
                        </span>
                        <p className="candidate-info--text">
                          {" "}
                          Is your name registered in any District Employment
                          Office located in Uttarakhand State?
                        </p>
                      </div>
                      <div className="w-20">
                        <p className="candidate-info--subText txtRight">
                          {Number(
                            candidateData?.is_your_name_registered_any_district_employment
                          ) === 1
                            ? "Yes"
                            : "No"}
                        </p>
                      </div>
                    </div>
                    {Number(
                      candidateData?.is_your_name_registered_any_district_employment
                    ) === 1 && (
                        <>
                          <div className="print-details d-flex">
                            <div className="w-80 d-flex">
                              <span
                                className="candidate-info--text"
                                style={{ marginRight: "10px" }}
                              >
                                1(i).
                              </span>
                              <p className="candidate-info--text">
                                Employee Registration Number
                              </p>
                            </div>
                            <div className="w-20">
                              <p className="candidate-info--subText">
                                {
                                  candidateData?.registered_any_district_employment_reg_no
                                }
                              </p>
                            </div>
                          </div>
                          <div className="print-details d-flex">
                            <div
                              className="w-80 d-flex"
                              style={{ marginRight: "10px" }}
                            >
                              <span
                                className="candidate-info--text"
                                style={{ marginRight: "10px" }}
                              >
                                1(ii).
                              </span>
                              <p className="candidate-info--text">
                                Employment Office District
                              </p>
                            </div>
                            <div className="w-20">
                              <p className="candidate-info--subText">
                                {
                                  candidateData?.registered_any_district_employment_ofc_district
                                }
                              </p>
                            </div>
                          </div>
                          <div className="print-details d-flex">
                            <div
                              className="w-80 d-flex"
                              style={{ marginRight: "10px" }}
                            >
                              <span
                                className="candidate-info--text"
                                style={{ marginRight: "10px" }}
                              >
                                1(iii).
                              </span>
                              <p className="candidate-info--text">
                                Date of Registration
                              </p>
                            </div>
                            <div className="w-20">
                              <p className="candidate-info--subText">
                                {fDate(
                                  candidateData?.registered_any_district_employment_date_of_registration,
                                  "dd/MM/yyyy"
                                )}
                              </p>
                            </div>
                          </div>
                          <div className="print-details d-flex">
                            <div
                              className="w-80 d-flex"
                              style={{ marginRight: "10px" }}
                            >
                              <span
                                className="candidate-info--text"
                                style={{ marginRight: "10px" }}
                              >
                                1(iv).
                              </span>
                              <p className="candidate-info--text">
                                Registration Date Valid Up to
                              </p>
                            </div>
                            <div className="w-20" style={{ marginRight: "10px" }}>
                              <p className="candidate-info--subText">
                                {fDate(
                                  candidateData?.registered_any_district_employment_registration_date_valid_upto,
                                  "dd/MM/yyyy"
                                )}
                              </p>
                            </div>
                          </div>
                        </>
                      )}
                    <div className="print-details d-flex">
                      <div
                        className="w-80 d-flex"
                        style={{ marginRight: "10px" }}
                      >
                        <span
                          className="candidate-info--text"
                          style={{ marginRight: "10px" }}
                        >
                          2.
                        </span>
                        <p className="candidate-info--text">
                          {" "}
                          Are You Employed?
                        </p>
                      </div>
                      <div className="w-20">
                        <p className="candidate-info--subText custom-rht2">
                          {Number(candidateData?.is_employed) === 1
                            ? "Yes"
                            : "No"}
                        </p>
                      </div>
                    </div>
                    {Number(candidateData?.is_employed) === 1 && (
                      <>
                        <div className="print-details d-flex">
                          <div
                            className="w-80 d-flex"
                            style={{ marginRight: "10px" }}
                          >
                            <span
                              className="candidate-info--text"
                              style={{ marginRight: "10px" }}
                            >
                              2(i).
                            </span>
                            <p className="candidate-info--text">
                              Type of Organisation
                            </p>
                          </div>
                          <div className="w-20">
                            <p className="candidate-info--subText">
                              {candidateData?.employee_organization_type}
                            </p>
                          </div>
                        </div>
                        <div className="print-details d-flex">
                          <div
                            className="w-80 d-flex"
                            style={{ marginRight: "10px" }}
                          >
                            <span
                              className="candidate-info--text"
                              style={{ marginRight: "10px" }}
                            >
                              2(ii).
                            </span>
                            <p className="candidate-info--text">
                              Date of Applying NOC
                            </p>
                          </div>
                          <div className="w-20">
                            <p className="candidate-info--subText">
                              {fDate(
                                candidateData?.employee_organization_noc,
                                "dd/MM/yyyy"
                              )}
                            </p>
                          </div>
                        </div>
                      </>
                    )}
                    <div className="print-details d-flex">
                      <div
                        className="w-80 d-flex"
                        style={{ marginRight: "10px" }}
                      >
                        <span
                          className="candidate-info--text"
                          style={{ marginRight: "10px" }}
                        >
                          3.
                        </span>
                        <p className="candidate-info--text">
                          {" "}
                          Have you passed your High School and Intermediate or
                          any other equivalent exam from any recognized
                          institution situated in the State of Uttarakhand
                        </p>
                      </div>
                      <div className="w-20">
                        <p className="candidate-info--subText custom-rht2">
                          {Number(
                            candidateData?.is_passed_hs_s_school_any_other_exam
                          ) === 1
                            ? "Yes"
                            : "No"}
                        </p>
                      </div>
                    </div>
                    <div className="print-details d-flex">
                      <div
                        className="w-80 d-flex"
                        style={{ marginRight: "10px" }}
                      >
                        <span
                          className="candidate-info--text"
                          style={{ marginRight: "10px" }}
                        >
                          4(i).
                        </span>
                        <p className="candidate-info--text">
                          {" "}
                          Are you or your spouse or your parents regular
                          employees of the Armed Forces/Paramilitary Forces
                          serving in the state of Uttarakhand and whose services
                          cannot be transferred outside the state of
                          Uttarakhand?
                        </p>
                      </div>
                      <div className="w-20">
                        <p className="candidate-info--subText custom-rht2">
                          {Number(
                            candidateData?.is_your_spouse_parents_regular_employees_forces
                          ) === 1
                            ? "Yes"
                            : "No"}
                        </p>
                      </div>
                    </div>
                    <div className="print-details d-flex">
                      <div
                        className="w-80 d-flex"
                        style={{ marginRight: "10px" }}
                      >
                        <span
                          className="candidate-info--text"
                          style={{ marginRight: "10px" }}
                        >
                          4(ii).
                        </span>
                        <p className="candidate-info--text">
                          {" "}
                          Are you or your spouse or your parents regular
                          employees of the State Government/Semi Government
                          organisation serving on a regular basis in the state
                          of Uttarakhand and whose services cannot be
                          transferred outside the state of Uttarakhand?
                        </p>
                      </div>
                      <div className="w-20">
                        <p className="candidate-info--subText custom-rht2">
                          {Number(
                            candidateData?.is_your_spouse_parents_regular_employees_state_govt
                          ) === 1
                            ? "Yes"
                            : "No"}
                        </p>
                      </div>
                    </div>
                    <div className="print-details d-flex">
                      <div
                        className="w-80 d-flex"
                        style={{ marginRight: "10px" }}
                      >
                        <span
                          className="candidate-info--text"
                          style={{ marginRight: "10px" }}
                        >
                          4(iii).
                        </span>
                        <p className="candidate-info--text">
                          {" "}
                          Are you or your spouse or your parents regular
                          employees of Central Government organisation/ Central
                          Government Public Service Undertaking and are working
                          regularly in the State of Uttarakhand and whose
                          services cannot be transferred outside the State of
                          Uttarakhand?
                        </p>
                      </div>
                      <div className="w-20">
                        <p className="candidate-info--subText custom-rht2">
                          {Number(
                            candidateData?.is_your_spouse_parents_regular_employees_central_govt
                          ) === 1
                            ? "Yes"
                            : "No"}
                        </p>
                      </div>
                    </div>
                    <div className="print-details d-flex">
                      <div
                        className="w-80 d-flex"
                        style={{ marginRight: "10px" }}
                      >
                        <span
                          className="candidate-info--text"
                          style={{ marginRight: "10px" }}
                        >
                          5(i).
                        </span>
                        <p className="candidate-info--text">
                          {" "}
                          Are you permanent resident of Uttarakhand but residing
                          outside Uttarakhand for livelihood/education purposes?
                        </p>
                      </div>
                      <div className="w-20">
                        <p className="candidate-info--subText custom-rht2">
                          {Number(
                            candidateData?.is_permanent_resident_of_uk_but_reside_uk
                          ) === 1
                            ? "Yes"
                            : "No"}
                        </p>
                      </div>
                    </div>
                    {/* ******* */}
                    <div className="print-details d-flex">
                      <div
                        className="w-80 d-flex"
                        style={{ marginRight: "10px" }}
                      >
                        <span
                          className="candidate-info--text"
                          style={{ marginRight: "10px" }}
                        >
                          5(ii).
                        </span>
                        <p className="candidate-info--text">
                          {" "}
                          Is your spouse or your parents permanent residents of
                          Uttarakhand but are residing outside Uttarakhand for
                          livelihood/education purposes?
                        </p>
                      </div>
                      <div className="w-20">
                        <p className="candidate-info--subText custom-rht2">
                          {Number(
                            candidateData?.is_spouse_parents_permanent_resident_of_uk_but_reside_outside_uk
                          ) === 1
                            ? "Yes"
                            : "No"}
                        </p>
                      </div>
                    </div>
                  </div>
                </fieldset>
                <fieldset className="candidate-info--fieldset">
                  <legend className="candidate-info--legend">
                    Category / Sub Category Reservation Details
                  </legend>
                  {/* for web preview */}
                  <div className="print-web">
                    <Grid container spacing={1} alignItems={"center"}>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--text">Category</p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--subText custom-rht2">
                          {candidateData?.category}
                        </p>
                      </Grid>
                      {/* {candidateData?.category === "EWS" && (
                          <>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                              <p className="candidate-info--textred">
                                आर्थिक रूप से कमजोर वर्ग
                              </p>
                            </Grid>
                            <Grid item lg={6} md={6} sm={0} xs={0}></Grid>
                          </>
                        )} */}
                      {candidateData?.certification_issuing_authority && (
                        <>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--text">
                              Certification Issuing Authority
                            </p>
                          </Grid>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--subText">
                              {candidateData?.certification_issuing_authority}
                            </p>
                          </Grid>
                        </>
                      )}
                      {candidateData?.certification_issuing_date && (
                        <>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--text">
                              Certificate Issuing Date
                            </p>
                          </Grid>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--subText">
                              {fDate(
                                candidateData?.certification_issuing_date,
                                "dd/MM/yyyy"
                              )}
                            </p>
                          </Grid>
                        </>
                      )}
                      {candidateData?.certification_no && (
                        <>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--text">
                              Certificate Number
                            </p>
                          </Grid>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--subText">
                              {candidateData?.certification_no}
                            </p>
                          </Grid>
                        </>
                      )}
                      {candidateData?.certification_issuing_district && (
                        <>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--text">
                              Certificate Issuing District
                            </p>
                          </Grid>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--subText">
                              {candidateData?.certification_issuing_district}
                            </p>
                          </Grid>
                        </>
                      )}
                      {candidateData?.certification_valid_upto && (
                        <>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--text">Valid Upto</p>
                          </Grid>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--subText">
                              {fDate(
                                candidateData?.certification_valid_upto,
                                "dd/MM/yyyy"
                              )}
                            </p>
                          </Grid>
                        </>
                      )}

                      {Number(candidateData?.domicile) === 1 && (
                        <>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <p className="candidate-info--subheading">
                              Sub Category Details
                            </p>
                          </Grid>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--text">
                              Differently abled(PH)
                            </p>
                          </Grid>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--subText">
                              {Number(candidateData?.is_differently_abled) === 1
                                ? "Yes"
                                : "No"}
                            </p>
                          </Grid>
                          {Number(candidateData?.is_differently_abled) ===
                            1 && (
                              <>
                                <Grid item lg={6} md={6} sm={6} xs={6}>
                                  <p className="candidate-info--text">
                                    Differently abled Type
                                  </p>
                                </Grid>
                                <Grid item lg={6} md={6} sm={6} xs={6}>
                                  <p className="candidate-info--subText">
                                    {Number(
                                      candidateData?.is_differently_abled
                                    ) === 1
                                      ? candidateData?.differently_abled_type
                                      : ""}
                                  </p>
                                </Grid>
                                <Grid item lg={6} md={6} sm={6} xs={6}>
                                  <p className="candidate-info--text">
                                    Certificate Issuing Date
                                  </p>
                                </Grid>
                                <Grid item lg={6} md={6} sm={6} xs={6}>
                                  <p className="candidate-info--subText">
                                    {fDate(
                                      candidateData?.differently_abled_certification_issuing_date,
                                      "dd/MM/yyyy"
                                    )}
                                  </p>
                                </Grid>
                                <Grid item lg={6} md={6} sm={6} xs={6}>
                                  <p className="candidate-info--text">
                                    Certificate Number
                                  </p>
                                </Grid>
                                <Grid item lg={6} md={6} sm={6} xs={6}>
                                  <p className="candidate-info--subText">
                                    {
                                      candidateData?.differently_abled_certificate_no
                                    }
                                  </p>
                                </Grid>
                                <Grid item lg={6} md={6} sm={6} xs={6}>
                                  <p className="candidate-info--text">
                                    Do you need a scribe?
                                  </p>
                                </Grid>
                                <Grid item lg={6} md={6} sm={6} xs={6}>
                                  <p className="candidate-info--subText">
                                    {Number(candidateData?.need_scribe) === 1
                                      ? "Yes"
                                      : "No"}
                                  </p>
                                </Grid>
                                {Number(candidateData?.need_scribe) === 1 && (
                                  <>
                                    <Grid item lg={6} md={6} sm={6} xs={6}>
                                      <p className="candidate-info--text">
                                        Will you bring your own scribe?
                                      </p>
                                    </Grid>
                                    <Grid item lg={6} md={6} sm={6} xs={6}>
                                      <p className="candidate-info--subText">
                                        {Number(candidateData?.own_scribe) === 1
                                          ? "Yes"
                                          : "No"}
                                      </p>
                                    </Grid>
                                  </>
                                )}
                              </>
                            )}
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--text">
                              Ex-Servicemen
                            </p>
                          </Grid>

                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--subText">
                              {Number(candidateData?.is_exserviceman) === 1
                                ? "Yes"
                                : "No"}
                            </p>
                          </Grid>
                          {Number(candidateData?.is_exserviceman) === 1 && (
                            <>
                              <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className="candidate-info--text">
                                  Date of Attestation
                                </p>
                              </Grid>
                              <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className="candidate-info--subText">
                                  {fDate(
                                    candidateData?.exserviceman_attestation_date,
                                    "dd/MM/yyyy"
                                  )}
                                </p>
                              </Grid>
                              <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className="candidate-info--text">
                                  Date of Discharge
                                </p>
                              </Grid>
                              <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className="candidate-info--subText">
                                  {fDate(
                                    candidateData?.exserviceman_discharge_date,
                                    "dd/MM/yyyy"
                                  )}
                                </p>
                              </Grid>
                              <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className="candidate-info--text">
                                  Have you availed the benefits of an
                                  ex-servicemen in any government job in the
                                  past?
                                </p>
                              </Grid>
                              <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className="candidate-info--subText">
                                  {Number(
                                    candidateData?.exservicemen_availed_benefits
                                  ) === 1
                                    ? "Yes"
                                    : "No"}
                                </p>
                              </Grid>
                              {Number(
                                candidateData?.exservicemen_availed_benefits
                              ) === 1 && (
                                  <>
                                    <Grid item lg={6} md={6} sm={6} xs={6}>
                                      <p className="candidate-info--text">
                                        Have you secured employment under the
                                        state government in group C&D and are
                                        applying for another employment in a
                                        higher grade or cadre in Group C/D under
                                        the state government
                                      </p>
                                    </Grid>
                                    <Grid item lg={6} md={6} sm={6} xs={6}>
                                      <p className="candidate-info--subText">
                                        {Number(
                                          candidateData?.under_state_govt_group_cd_apply_another_group
                                        ) === 1
                                          ? "Yes"
                                          : "No"}
                                      </p>
                                    </Grid>
                                  </>
                                )}
                              <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className="candidate-info--text">
                                  Is your name registered in any District
                                  Soldier Welfare and Rehabilitation Office
                                  Employment Exchange located in Uttarakhand
                                  State?
                                </p>
                              </Grid>
                              <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className="candidate-info--subText">
                                  {Number(
                                    candidateData?.is_registered_district_soldier_welfare
                                  ) === 1
                                    ? "Yes"
                                    : "No"}
                                </p>
                              </Grid>
                              {/* {Number(
                                  candidateData?.exservicemen_availed_benefits
                                ) === 1 && (
                                    <>
                                      <Grid item lg={6} md={6} sm={6} xs={6}>
                                        <p className="candidate-info--textred print-none">
                                          (As per advertisement you are not eligible
                                          to avail the benefits of ex-servicemen
                                          reservation category. You can continue as
                                          Non-Ex-Servicemen candidate.)
                                        </p>
                                      </Grid>
                                      <Grid item lg={6} md={6} sm={6} xs={6} />
                                    </>
                                  )} */}
                            </>
                          )}
                          {Number(
                            candidateData?.is_registered_district_soldier_welfare
                          ) === 1 && (
                              <>
                                <Grid item lg={6} md={6} sm={6} xs={6}>
                                  <p className="candidate-info--text">
                                    Enter Registration Number
                                  </p>
                                </Grid>
                                <Grid item lg={6} md={6} sm={6} xs={6}>
                                  <p className="candidate-info--subText">
                                    {
                                      candidateData?.district_soldier_welfare_registration_no
                                    }
                                  </p>
                                </Grid>

                                <Grid item lg={6} md={6} sm={6} xs={6}>
                                  <p className="candidate-info--text">
                                    Office Name
                                  </p>
                                </Grid>
                                <Grid item lg={6} md={6} sm={6} xs={6}>
                                  <p className="candidate-info--subText">
                                    {
                                      candidateData?.district_soldier_welfare_office_name
                                    }
                                  </p>
                                </Grid>
                                <Grid item lg={6} md={6} sm={6} xs={6}>
                                  <p className="candidate-info--text">
                                    Date of Registration
                                  </p>
                                </Grid>
                                <Grid item lg={6} md={6} sm={6} xs={6}>
                                  <p className="candidate-info--subText">
                                    {fDate(
                                      candidateData?.district_soldier_welfare_registration_date,
                                      "dd/MM/yyyy"
                                    )}
                                  </p>
                                </Grid>
                              </>
                            )}

                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--text">
                              Dependent of Freedom Fighter (DFF)
                            </p>
                          </Grid>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--subText">
                              {Number(candidateData?.dff) === 1 ? "Yes" : "No"}
                            </p>
                          </Grid>
                          {Number(candidateData?.dff) === 1 && (
                            <>
                              <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className="candidate-info--text">
                                  Certificate Issuing Date
                                </p>
                              </Grid>
                              <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className="candidate-info--subText">
                                  {fDate(
                                    candidateData?.dff_certification_issuing_date,
                                    "dd/MM/yyyy"
                                  )}
                                </p>
                              </Grid>
                              <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className="candidate-info--text">
                                  Certificate Number
                                </p>
                              </Grid>
                              <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className="candidate-info--subText">
                                  {candidateData?.dff_certificate_no}
                                </p>
                              </Grid>
                            </>
                          )}
                          <Grid item lg={6} md={6} sm={6} xs={6} pr={6}>
                            <p className="candidate-info--text">
                              Are you a permanent resident of the State of
                              Uttarakhand covered by Government Order No.
                              179/XXX(2)/2021-30(2)/2019, dated 31st August
                              2021, for such affected children (whose
                              biological/adoptive parents both died after the
                              birth of the child)? within a period of up to 21
                              years) OR Orphan Child residing in
                              government/voluntary homes functional and
                              registered under the Department of Women
                              Empowerment and Child Development in the state of
                              Uttarakhand
                            </p>
                          </Grid>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--subText">
                              {Number(
                                candidateData?.permanent_resident_uttarakhand_covered_by_govt_order
                              ) === 1
                                ? "Yes"
                                : "No"}
                            </p>
                          </Grid>
                          {Number(
                            candidateData?.permanent_resident_uttarakhand_covered_by_govt_order
                          ) === 1 && (
                              <>
                                <Grid item lg={6} md={6} sm={6} xs={6}>
                                  <p className="candidate-info--text">
                                    Certificate Issuing Date
                                  </p>
                                </Grid>
                                <Grid item lg={6} md={6} sm={6} xs={6}>
                                  <p className="candidate-info--subText">
                                    {fDate(
                                      candidateData?.orphan_certification_issuing_date,
                                      "dd/MM/yyyy"
                                    )}
                                  </p>
                                </Grid>
                                <Grid item lg={6} md={6} sm={6} xs={6}>
                                  <p className="candidate-info--text">
                                    Certificate Number
                                  </p>
                                </Grid>
                                <Grid item lg={6} md={6} sm={6} xs={6}>
                                  <p className="candidate-info--subText">
                                    {candidateData?.orphan_certificate_no}
                                  </p>
                                </Grid>
                              </>
                            )}
                          {candidateData?.gender === "Female" && (
                            <>
                              <Grid item lg={6} md={6} sm={6} xs={6} pr={6}>
                                <p className="make-payment--text">
                                  Uttarakhand Female
                                </p>
                              </Grid>
                              <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className="make-payment--subText">
                                  {Number(
                                    candidateData?.is_uttarakhand_female
                                  ) === 1
                                    ? "Yes"
                                    : "No"}
                                </p>
                              </Grid>
                            </>
                          )}
                        </>
                      )}

                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--text">
                          Claimed Category/Sub Category <br />
                          <span className="print-none">
                            (Reservation,Age ,Fee, Relaxation and other
                            applicable benefit)
                          </span>
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--subText boldBlue">
                          {claimedMsg}
                        </p>
                      </Grid>
                    </Grid>
                  </div>
                  {/* for print preview */}
                  <div className="print-view  requiredSec">
                    <div className="print-details d-flex">
                      <div className="w-50">
                        <p className="candidate-info--text">Category</p>
                      </div>
                      <div className="w-50">
                        <p className="candidate-info--subText custom-rht2">
                          {candidateData?.category}
                        </p>
                      </div>
                    </div>
                    {candidateData?.certification_issuing_authority && (
                      <div className="print-details d-flex">
                        <div className="w-50">
                          <p className="candidate-info--text">
                            Certification Issuing Authority
                          </p>
                        </div>
                        <div className="w-50">
                          <p className="candidate-info--subText">
                            {candidateData?.certification_issuing_authority}
                          </p>
                        </div>
                      </div>
                    )}
                    {candidateData?.certification_issuing_date && (
                      <div className="print-details d-flex">
                        <div className="w-50">
                          <p className="candidate-info--text">
                            Certificate Issuing Date
                          </p>
                        </div>
                        <div className="w-50">
                          <p className="candidate-info--subText">
                            {fDate(
                              candidateData?.certification_issuing_date,
                              "dd/MM/yyyy"
                            )}
                          </p>
                        </div>
                      </div>
                    )}
                    {candidateData?.certification_no && (
                      <div className="print-details d-flex">
                        <div className="w-50">
                          <p className="candidate-info--text">
                            Certificate Number
                          </p>
                        </div>
                        <div className="w-50">
                          <p className="candidate-info--subText">
                            {candidateData?.certification_no}
                          </p>
                        </div>
                      </div>
                    )}
                    {candidateData?.certification_issuing_district && (
                      <div className="print-details d-flex">
                        <div className="w-50">
                          <p className="candidate-info--text">
                            Certificate Issuing District
                          </p>
                        </div>
                        <div className="w-50">
                          <p className="candidate-info--subText">
                            {candidateData?.certification_issuing_district}
                          </p>
                        </div>
                      </div>
                    )}
                    {candidateData?.certification_valid_upto && (
                      <div className="print-details d-flex">
                        <div className="w-50">
                          <p className="candidate-info--text">Valid Upto</p>
                        </div>
                        <div className="w-50">
                          <p className="candidate-info--subText">
                            {fDate(
                              candidateData?.certification_valid_upto,
                              "dd/MM/yyyy"
                            )}
                          </p>
                        </div>
                      </div>
                    )}
                    {Number(candidateData?.domicile) === 1 && (
                      <>
                        <div className="print-details d-flex">
                          <div className="w-100">
                            <p className="candidate-info--subheading">
                              Sub Category Details
                            </p>
                          </div>
                        </div>
                        <div className="print-details d-flex">
                          <div className="w-50">
                            <p className="candidate-info--text">
                              Differently abled(PH)
                            </p>
                          </div>
                          <div className="w-50">
                            <p className="candidate-info--subText">
                              {Number(candidateData?.is_differently_abled) === 1
                                ? "Yes"
                                : "No"}
                            </p>
                          </div>
                        </div>
                        {Number(candidateData?.is_differently_abled) === 1 && (
                          <>
                            <div className="print-details d-flex">
                              <div className="w-50">
                                <p className="candidate-info--text">
                                  Differently abled Type
                                </p>
                              </div>
                              <div className="w-50">
                                <p className="candidate-info--subText">
                                  {Number(
                                    candidateData?.is_differently_abled
                                  ) === 1
                                    ? candidateData?.differently_abled_type
                                    : ""}
                                </p>
                              </div>
                            </div>
                            <div className="print-details d-flex">
                              <div className="w-50">
                                <p className="candidate-info--text">
                                  Certificate Issuing Date
                                </p>
                              </div>
                              <div className="w-50">
                                <p className="candidate-info--subText">
                                  {fDate(
                                    candidateData?.differently_abled_certification_issuing_date,
                                    "dd/MM/yyyy"
                                  )}
                                </p>
                              </div>
                            </div>
                            <div className="print-details d-flex">
                              <div className="w-50">
                                <p className="candidate-info--text">
                                  Certificate Number
                                </p>
                              </div>
                              <div className="w-50">
                                <p className="candidate-info--subText">
                                  {
                                    candidateData?.differently_abled_certificate_no
                                  }
                                </p>
                              </div>
                            </div>
                            <div className="print-details d-flex">
                              <div className="w-50">
                                <p className="candidate-info--text">
                                  Do you need a scribe?
                                </p>
                              </div>
                              <div className="w-50">
                                <p className="candidate-info--subText">
                                  {Number(candidateData?.need_scribe) === 1
                                    ? "Yes"
                                    : "No"}
                                </p>
                              </div>
                            </div>
                            {Number(candidateData?.need_scribe) === 1 && (
                              <div className="print-details d-flex">
                                <div className="w-50">
                                  <p className="candidate-info--text">
                                    Will you bring your own scribe?
                                  </p>
                                </div>
                                <div className="w-50">
                                  <p className="candidate-info--subText">
                                    {Number(candidateData?.own_scribe) === 1
                                      ? "Yes"
                                      : "No"}
                                  </p>
                                </div>
                              </div>
                            )}
                          </>
                        )}
                        <div className="print-details d-flex">
                          <div className="w-50">
                            <p className="candidate-info--text">
                              Ex-Servicemen
                            </p>
                          </div>
                          <div className="w-50">
                            <p className="candidate-info--subText">
                              {Number(candidateData?.is_exserviceman) === 1
                                ? "Yes"
                                : "No"}
                            </p>
                          </div>
                        </div>
                        {Number(candidateData?.is_exserviceman) === 1 && (
                          <>
                            <div className="print-details d-flex">
                              <div className="w-50">
                                <p className="candidate-info--text">
                                  Date of Attestation
                                </p>
                              </div>
                              <div className="w-50">
                                <p className="candidate-info--subText">
                                  {fDate(
                                    candidateData?.exserviceman_attestation_date,
                                    "dd/MM/yyyy"
                                  )}
                                </p>
                              </div>
                            </div>
                            <div className="print-details d-flex">
                              <div className="w-50">
                                <p className="candidate-info--text">
                                  Date of Discharge
                                </p>
                              </div>
                              <div className="w-50">
                                <p className="candidate-info--subText">
                                  {fDate(
                                    candidateData?.exserviceman_discharge_date,
                                    "dd/MM/yyyy"
                                  )}
                                </p>
                              </div>
                            </div>
                            <div className="print-details d-flex">
                              <div className="w-50">
                                <p className="candidate-info--text">
                                  Have you availed the benefits of an
                                  ex-servicemen in any government job in the
                                  past?
                                </p>
                              </div>
                              <div className="w-50">
                                <p className="candidate-info--subText">
                                  {Number(
                                    candidateData?.exservicemen_availed_benefits
                                  ) === 1
                                    ? "Yes"
                                    : "No"}
                                </p>
                              </div>
                            </div>
                            {Number(
                              candidateData?.exservicemen_availed_benefits
                            ) === 1 && (
                                <div className="print-details d-flex">
                                  <div className="w-50">
                                    <p className="candidate-info--text">
                                      Have you secured employment under the state
                                      government in group C&D and are applying for
                                      another employment in a higher grade or
                                      cadre in Group C/D under the state
                                      government?
                                    </p>
                                  </div>
                                  <div className="w-50">
                                    <p className="candidate-info--subText">
                                      {Number(
                                        candidateData?.under_state_govt_group_cd_apply_another_group
                                      ) === 1
                                        ? "Yes"
                                        : "No"}
                                    </p>
                                  </div>
                                </div>
                              )}
                            <div className="print-details d-flex">
                              <div className="w-50">
                                <p className="candidate-info--text">
                                  Is your name registered in any District
                                  Soldier Welfare and Rehabilitation Office
                                  Employment Exchange located in Uttarakhand
                                  State?
                                </p>
                              </div>
                              <div className="w-50">
                                <p className="candidate-info--subText">
                                  {Number(
                                    candidateData?.is_registered_district_soldier_welfare
                                  ) === 1
                                    ? "Yes"
                                    : "No"}
                                </p>
                              </div>
                            </div>
                          </>
                        )}
                        {Number(
                          candidateData?.is_registered_district_soldier_welfare
                        ) === 1 && (
                            <>
                              <div className="print-details d-flex">
                                <div className="w-50">
                                  <p className="candidate-info--text">
                                    Enter Registration Number
                                  </p>
                                </div>
                                <div className="w-50">
                                  <p className="candidate-info--subText">
                                    {
                                      candidateData?.district_soldier_welfare_registration_no
                                    }
                                  </p>
                                </div>
                              </div>
                              <div className="print-details d-flex">
                                <div className="w-50">
                                  <p className="candidate-info--text">
                                    Office Name
                                  </p>
                                </div>
                                <div className="w-50">
                                  <p className="candidate-info--subText">
                                    {
                                      candidateData?.district_soldier_welfare_office_name
                                    }
                                  </p>
                                </div>
                              </div>
                              <div className="print-details d-flex">
                                <div className="w-50">
                                  <p className="candidate-info--text">
                                    Date of Registration
                                  </p>
                                </div>
                                <div className="w-50">
                                  <p className="candidate-info--subText">
                                    {fDate(
                                      candidateData?.district_soldier_welfare_registration_date,
                                      "dd/MM/yyyy"
                                    )}
                                  </p>
                                </div>
                              </div>
                            </>
                          )}

                        <div className="print-details d-flex">
                          <div className="w-50">
                            <p className="candidate-info--text">
                              Dependent of Freedom Fighter (DFF)
                            </p>
                          </div>
                          <div className="w-50">
                            <p className="candidate-info--subText">
                              {Number(candidateData?.dff) === 1 ? "Yes" : "No"}
                            </p>
                          </div>
                        </div>
                        <div className="print-details d-flex">
                          <div className="w-50">
                            <p className="candidate-info--text">
                              Are you a permanent resident of the State of
                              Uttarakhand covered by Government Order No.
                              179/XXX(2)/2021-30(2)/2019, dated 31st August
                              2021, for such affected children (whose
                              biological/adoptive parents both died after the
                              birth of the child)? within a period of up to 21
                              years) OR Orphan Child residing in
                              government/voluntary homes functional and
                              registered under the Department of Women
                              Empowerment and Child Development in the state of
                              Uttarakhand
                            </p>
                          </div>
                          <div className="w-50">
                            <p className="candidate-info--subText">
                              {Number(
                                candidateData?.permanent_resident_uttarakhand_covered_by_govt_order
                              ) === 1
                                ? "Yes"
                                : "No"}
                            </p>
                          </div>
                        </div>

                        {candidateData?.gender === "Female" && (
                          <div className="print-details d-flex">
                            <div className="w-50">
                              <p className="candidate-info--text">
                                Uttarakhand Female
                              </p>
                            </div>
                            <div className="w-50">
                              <p className="candidate-info--subText">
                                {Number(
                                  candidateData?.is_uttarakhand_female
                                ) === 1
                                  ? "Yes"
                                  : "No"}
                              </p>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    <div className="print-details d-flex">
                      <div className="w-50">
                        <p className="candidate-info--text">
                          Claimed Category/Sub Category <br />
                          <span className="print-none">
                            (Reservation,Age ,Fee, Relaxation and other
                            applicable benefit)
                          </span>
                        </p>
                      </div>
                      <div className="w-50">
                        <p className="candidate-info--subText boldBlue">
                          {claimedMsg}
                        </p>
                      </div>
                    </div>
                  </div>
                </fieldset>
                <fieldset className="candidate-info--fieldsetBox">
                  <legend className="candidate-info--legend">
                    Address Details
                  </legend>
                  <fieldset className="candidate-info--subFieldset toppy">
                    <legend className="candidate-info--legend">
                      Present Address
                    </legend>
                    <Grid container spacing={0}>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="dummyTxt candidate-info--text">Line1</p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="dummyTxt candidate-info--subText">
                          {candidateData?.present_address_line1}
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="dummyTxt candidate-info--text">Line2</p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="dummyTxt candidate-info--subText">
                          {candidateData?.present_address_line2}
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="dummyTxt candidate-info--text">
                          City / Town / Village
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="dummyTxt candidate-info--subText">
                          {candidateData?.present_city}
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="dummyTxt candidate-info--text">
                          District
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="dummyTxt candidate-info--subText">
                          {candidateData?.present_district_id}
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="dummyTxt candidate-info--text">State</p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="dummyTxt candidate-info--subText">
                          {candidateData?.present_state_id}
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="dummyTxt candidate-info--text">Pincode</p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="dummyTxt candidate-info--subText">
                          {candidateData?.present_pincode}
                        </p>
                      </Grid>
                    </Grid>
                  </fieldset>
                  <fieldset className="candidate-info--subFieldset toppyBottom">
                    <legend className="candidate-info--legend">
                      Permanent Address
                    </legend>
                    <Grid container spacing={0}>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="dummyTxt candidate-info--text">Line1</p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="dummyTxt candidate-info--subText">
                          {candidateData?.permanent_address_line1}
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="dummyTxt candidate-info--text">Line2</p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="dummyTxt candidate-info--subText">
                          {candidateData?.permanent_address_line2}
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="dummyTxt candidate-info--text">
                          City / Town / Village
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="dummyTxt candidate-info--subText">
                          {candidateData?.permanent_city}
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="dummyTxt candidate-info--text">
                          District
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="dummyTxt candidate-info--subText">
                          {candidateData?.permanent_district_id}
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="dummyTxt candidate-info--text">State</p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="dummyTxt candidate-info--subText">
                          {candidateData?.permanent_state_id}
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="dummyTxt candidate-info--text">Pincode</p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="dummyTxt candidate-info--subText">
                          {candidateData?.permanent_pincode}
                        </p>
                      </Grid>
                    </Grid>
                  </fieldset>
                </fieldset>
                <fieldset className="candidate-info--fieldset">
                  <legend className="candidate-info--legend">
                    Educational Qualifications Details
                  </legend>
                  <div className="print-web">
                    <Grid container spacing={1}>
                      {/* <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--text">
                          Do you Possess thorough knowledge of Hindi in Devnagri
                          script?
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--subText custom-rht">
                          {String(
                            candidateData?.knowledge_hindi_devnagari_script
                          ) === "1" && "Yes"}
                          {String(
                            candidateData?.knowledge_hindi_devnagari_script
                          ) === "0" && "No"}
                          {String(
                            candidateData?.knowledge_hindi_devnagari_script
                          ) !== "1" &&
                            String(
                              candidateData?.knowledge_hindi_devnagari_script
                            ) !== "0" &&
                            "-"}
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--text">
                          Do you have basic knowledge of Computer operation?
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--subText">
                          {String(
                            candidateData?.knowledge_computer_operation
                          ) === "1" && "Yes"}
                          {String(
                            candidateData?.knowledge_computer_operation
                          ) === "0" && "No"}
                          {String(
                            candidateData?.knowledge_computer_operation
                          ) !== "1" &&
                            String(
                              candidateData?.knowledge_computer_operation
                            ) !== "0" &&
                            "-"}
                        </p>
                      </Grid> */}
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <EducationDetailsTable
                          data={candidateData?.educationDetails}
                        />
                      </Grid>
                    </Grid>
                  </div>
                  <div className="print-view">
                    {/* <div className="print-details d-flex">
                      <div className="w-60">
                        <p className="candidate-info--text">
                          Do you Possess thorough knowledge of Hindi in Devnagri
                          script?
                        </p>
                      </div>
                      <div className="w-40">
                        <p className="candidate-info--subText">
                          {String(
                            candidateData?.knowledge_hindi_devnagari_script
                          ) === "1" && "Yes"}
                          {String(
                            candidateData?.knowledge_hindi_devnagari_script
                          ) === "0" && "No"}
                          {String(
                            candidateData?.knowledge_hindi_devnagari_script
                          ) !== "1" &&
                            String(
                              candidateData?.knowledge_hindi_devnagari_script
                            ) !== "0" &&
                            "-"}
                        </p>
                      </div>
                    </div>
                    <div className="print-details d-flex">
                      <div className="w-60">
                        <p className="candidate-info--text">
                          Do you have basic knowledge of Computer operation?
                        </p>
                      </div>
                      <div className="w-40">
                        <p className="candidate-info--subText">
                          {String(
                            candidateData?.knowledge_computer_operation
                          ) === "1" && "Yes"}
                          {String(
                            candidateData?.knowledge_computer_operation
                          ) === "0" && "No"}
                          {String(
                            candidateData?.knowledge_computer_operation
                          ) !== "1" &&
                            String(
                              candidateData?.knowledge_computer_operation
                            ) !== "0" &&
                            "-"}
                        </p>
                      </div>
                    </div> */}
                    <Grid container spacing={1}>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <div className="candidate-info--table">
                          <EducationDetailsTable
                            data={candidateData?.educationDetails}
                          />
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </fieldset>
                <fieldset className="candidate-info--fieldset">
                  <legend className="candidate-info--legend">
                    Preferential Qualification
                  </legend>
                  {/* for web preview */}
                  <div className="print-web">
                    <Grid container spacing={1}>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--text">
                          Have you Served in the Territorial army for a minimum
                          period of two years?
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--subText custom-rht">
                          {String(candidateData?.is_served_territorial_army) ===
                            "1" && "Yes"}
                          {String(candidateData?.is_served_territorial_army) ===
                            "0" && "No"}
                          {String(candidateData?.is_served_territorial_army) !==
                            "1" &&
                            String(
                              candidateData?.is_served_territorial_army
                            ) !== "0" &&
                            "-"}
                        </p>
                      </Grid>
                      {Number(candidateData?.is_served_territorial_army) ===
                        1 ? (
                        <>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--text">
                              Date of Attestation
                            </p>
                          </Grid>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--subText">
                              {fDate(
                                candidateData?.ta_attestation_date,
                                "dd/MM/yyyy"
                              )}
                            </p>
                          </Grid>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--text">
                              Date of Discharge
                            </p>
                          </Grid>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--subText">
                              {fDate(
                                candidateData?.ta_discharge_date,
                                "dd/MM/yyyy"
                              )}
                            </p>
                          </Grid>
                        </>
                      ) : null}

                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--text">
                          Do you possesses "B" certificate of National Cadet
                          Corps?
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--subText custom-rht">
                          {String(candidateData?.is_b_ncc) === "1" && "Yes"}
                          {String(candidateData?.is_b_ncc) === "0" && "No"}
                          {String(candidateData?.is_b_ncc) !== "1" &&
                            String(candidateData?.is_b_ncc) !== "0" &&
                            "-"}
                        </p>
                      </Grid>
                      {Number(candidateData?.is_b_ncc) === 1 ? (
                        <>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--text">
                              National Cadet Corps "B" Acquiring Date{" "}
                            </p>
                          </Grid>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--subText">
                              {fDate(
                                candidateData?.b_ncc_acquiring_date,
                                "dd/MM/yyyy"
                              )}
                            </p>
                          </Grid>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--text">
                              National Cadet Corps "B" Certificate Number{" "}
                            </p>
                          </Grid>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--subText">
                              {candidateData?.b_ncc_certificate_no}
                            </p>
                          </Grid>
                        </>
                      ) : null}
                      {/* <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--text">
                          Do you possesses "C" certificate of National Cadet
                          Corps?
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--subText custom-rht">
                          {String(candidateData?.is_c_ncc) === "1" && "Yes"}
                          {String(candidateData?.is_c_ncc) === "0" && "No"}
                          {String(candidateData?.is_c_ncc) !== "1" &&
                            String(candidateData?.is_c_ncc) !== "0" &&
                            "-"}
                        </p>
                      </Grid>
                      {Number(candidateData?.is_c_ncc) === 1 ? (
                        <>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--text">
                              National Cadet Corps "C" Acquiring Date{" "}
                            </p>
                          </Grid>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--subText">
                              {fDate(
                                candidateData?.c_ncc_acquiring_date,
                                "dd/MM/yyyy"
                              )}
                            </p>
                          </Grid>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--text">
                              National Cadet Corps "C" Certificate Number{" "}
                            </p>
                          </Grid>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--subText">
                              {candidateData?.c_ncc_certificate_no}
                            </p>
                          </Grid>
                        </>
                      ) : null} */}

                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--text">
                          Do you possesses a Graduate Degree/Post Graduate
                          Degree with a lab subject as one of the subjects?
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--subText custom-rht">
                          {String(candidateData?.is_lab_subject) === "1" &&
                            "Yes"}
                          {String(candidateData?.is_lab_subject) === "0" &&
                            "No"}
                          {String(candidateData?.is_lab_subject) !== "1" &&
                            String(candidateData?.is_lab_subject) !== "0" &&
                            "-"}
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--text">
                          Do you possesses six months certificate in Computer
                          Operation from a reputed institution?
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--subText custom-rht">
                          {String(candidateData?.is_computer_certificate) ===
                            "1" && "Yes"}
                          {String(candidateData?.is_computer_certificate) ===
                            "0" && "No"}
                          {String(candidateData?.is_computer_certificate) !==
                            "1" &&
                            String(candidateData?.is_computer_certificate) !==
                            "0" &&
                            "-"}
                        </p>
                      </Grid>
                      {/* <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--text">
                          Do You Possesses 'B' Certificate of National Service
                          Scheme?
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--subText custom-rht">
                          {String(candidateData?.is_b_nss) === "1" && "Yes"}
                          {String(candidateData?.is_b_nss) === "0" && "No"}
                          {String(candidateData?.is_b_nss) !== "1" &&
                            String(candidateData?.is_b_nss) !== "0" &&
                            "-"}
                        </p>
                      </Grid>

                      {Number(candidateData?.is_b_nss) === 1 ? (
                        <>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--text">
                              National Service Scheme "B" Acquiring Date{" "}
                            </p>
                          </Grid>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--subText">
                              {fDate(candidateData?.b_nss_acquiring_date, 'dd/MM/yyyy')}
                            </p>
                          </Grid>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--text">
                              National Service Scheme "B" Certificate Number{" "}
                            </p>
                          </Grid>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--subText">
                              {candidateData?.b_nss_certificate_no}
                            </p>
                          </Grid>
                        </>
                      ) : null} */}
                    </Grid>
                  </div>
                  {/* for print view */}
                  <div className="print-view">

                    <div className="print-details d-flex">
                      <div className="w-80">
                        <p className="candidate-info--text">
                          Have you Served in the Territorial army for a minimum
                          period of two years?
                        </p>
                      </div>
                      <div className="w-20">
                        <p className="candidate-info--subText">
                          {String(candidateData?.is_served_territorial_army) ===
                            "1" && "Yes"}
                          {String(candidateData?.is_served_territorial_army) ===
                            "0" && "No"}
                          {String(candidateData?.is_served_territorial_army) !==
                            "1" &&
                            String(
                              candidateData?.is_served_territorial_army
                            ) !== "0" &&
                            "-"}
                        </p>
                      </div>
                    </div>
                    {Number(candidateData?.is_served_territorial_army) === 1 ? (
                      <>
                        <div className="print-details d-flex">
                          <div className="w-80">
                            <p className="candidate-info--text">
                              Date of Attestation
                            </p>
                          </div>
                          <div className="w-20">
                            <p className="candidate-info--subText">
                              {fDate(
                                candidateData?.ta_attestation_date,
                                "dd/MM/yyyy"
                              )}
                            </p>
                          </div>
                        </div>
                        <div className="print-details d-flex">
                          <div className="w-80">
                            <p className="candidate-info--text">
                              Date of Discharge
                            </p>
                          </div>
                          <div className="w-20">
                            <p className="candidate-info--subText">
                              {fDate(
                                candidateData?.ta_discharge_date,
                                "dd/MM/yyyy"
                              )}
                            </p>
                          </div>
                        </div>
                      </>
                    ) : null}

                    <div className="print-details d-flex">
                      <div className="w-80">
                        <p className="candidate-info--text">
                          Do you possesses "B" certificate of National Cadet
                          Corps?
                        </p>
                      </div>
                      <div className="w-20">
                        <p className="candidate-info--subText">
                          {String(candidateData?.is_b_ncc) === "1" && "Yes"}
                          {String(candidateData?.is_b_ncc) === "0" && "No"}
                          {String(candidateData?.is_b_ncc) !== "1" &&
                            String(candidateData?.is_b_ncc) !== "0" &&
                            "-"}
                        </p>
                      </div>
                    </div>
                    {Number(candidateData?.is_b_ncc) === 1 ? (
                      <>
                        <div className="print-details d-flex">
                          <div className="w-80">
                            <p className="candidate-info--text">
                              National Cadet Corps "B" Acquiring Date{" "}
                            </p>
                          </div>
                          <div className="w-20">
                            <p className="candidate-info--subText">
                              {fDate(
                                candidateData?.b_ncc_acquiring_date,
                                "dd/MM/yyyy"
                              )}
                            </p>
                          </div>
                        </div>
                        <div className="print-details d-flex">
                          <div className="w-80">
                            <p className="candidate-info--text">
                              National Cadet Corps "B" Certificate Number{" "}
                            </p>
                          </div>
                          <div className="w-20">
                            <p className="candidate-info--subText">
                              {candidateData?.b_ncc_certificate_no}
                            </p>
                          </div>
                        </div>
                      </>
                    ) : null}
                    {/* <div className="print-details d-flex">
                      <div className="w-80">
                        <p className="candidate-info--text">
                          Do you possesses "C" certificate of National Cadet
                          Corps?
                        </p>
                      </div>
                      <div className="w-20">
                        <p className="candidate-info--subText">
                          {String(candidateData?.is_c_ncc) === "1" && "Yes"}
                          {String(candidateData?.is_c_ncc) === "0" && "No"}
                          {String(candidateData?.is_c_ncc) !== "1" &&
                            String(candidateData?.is_c_ncc) !== "0" &&
                            "-"}
                        </p>
                      </div>
                    </div>
                    {Number(candidateData?.is_c_ncc) === 1 ? (
                      <>
                        <div className="print-details d-flex">
                          <div className="w-80">
                            <p className="candidate-info--text">
                              National Cadet Corps "C" Acquiring Date{" "}
                            </p>
                          </div>
                          <div className="w-20">
                            <p className="candidate-info--subText">
                              {fDate(
                                candidateData?.c_ncc_acquiring_date,
                                "dd/MM/yyyy"
                              )}
                            </p>
                          </div>
                        </div>
                        <div className="print-details d-flex">
                          <div className="w-80">
                            <p className="candidate-info--text">
                              National Cadet Corps "C" Certificate Number{" "}
                            </p>
                          </div>
                          <div className="w-20">
                            <p className="candidate-info--subText">
                              {candidateData?.c_ncc_certificate_no}
                            </p>
                          </div>
                        </div>
                      </>
                    ) : null} */}

                    <div className="print-details d-flex">
                      <div className="w-80">
                        <p className="candidate-info--text">
                          Do you possesses a Graduate Degree/Post Graduate
                          Degree with a lab subject as one of the subjects?
                        </p>
                      </div>
                      <div className="w-20">
                        <p className="candidate-info--subText">
                          {String(candidateData?.is_lab_subject) === "1" &&
                            "Yes"}
                          {String(candidateData?.is_lab_subject) === "0" &&
                            "No"}
                          {String(candidateData?.is_lab_subject) !== "1" &&
                            String(candidateData?.is_lab_subject) !== "0" &&
                            "-"}
                        </p>
                      </div>
                    </div>
                    <div className="print-details d-flex">
                      <div className="w-80">
                        <p className="candidate-info--text">
                          Do you possesses six months certificate in Computer
                          Operation from a reputed institution?
                        </p>
                      </div>
                      <div className="w-20">
                        <p className="candidate-info--subText">
                          {String(candidateData?.is_computer_certificate) ===
                            "1" && "Yes"}
                          {String(candidateData?.is_computer_certificate) ===
                            "0" && "No"}
                          {String(candidateData?.is_computer_certificate) !==
                            "1" &&
                            String(candidateData?.is_computer_certificate) !==
                            "0" &&
                            "-"}
                        </p>
                      </div>
                    </div>
                    {/* <div className="print-details d-flex">
                      <div className="w-80">
                        <p className="candidate-info--text">
                          Do You Possesses 'B' Certificate of National Service
                          Scheme?
                        </p>
                      </div>
                      <div className="w-20">
                        <p className="candidate-info--subText">
                          {String(candidateData?.is_b_nss) === "1" && "Yes"}
                          {String(candidateData?.is_b_nss) === "0" && "No"}
                          {String(candidateData?.is_b_nss) !== "1" &&
                            String(candidateData?.is_b_nss) !== "0" &&
                            "-"}
                        </p>
                      </div>
                    </div>
                    {Number(candidateData?.is_b_nss) === 1 ? (
                      <>
                        <div className="print-details d-flex">
                          <div className="w-80">
                            <p className="candidate-info--text">
                              National Service Scheme "B" Acquiring Date{" "}
                            </p>
                          </div>
                          <div className="w-20">
                            <p className="candidate-info--subText">
                              {fDate(candidateData?.b_nss_acquiring_date, 'dd/MM/yyyy')}
                            </p>
                          </div>
                        </div>
                        <div className="print-details d-flex">
                          <div className="w-80">
                            <p className="candidate-info--text">
                              National Service Scheme "B" Certificate Number{" "}
                            </p>
                          </div>
                          <div className="w-20">
                            <p className="candidate-info--subText">
                              {candidateData?.b_nss_certificate_no}
                            </p>
                          </div>
                        </div>
                      </>
                    ) : null} */}
                  </div>
                </fieldset>
                <fieldset className="candidate-info--fieldset">
                  <legend className="candidate-info--legend">
                    Other Details
                  </legend>
                  <div className="print-web">
                    <Grid container spacing={1}>
                      {/* <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--text">
                          Are You Employed?
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--subText">
                          {String(candidateData?.is_employed) === "1" && "Yes"}
                          {String(candidateData?.is_employed) === "0" && "No"}
                          {String(candidateData?.is_employed) !== "1" &&
                            String(candidateData?.is_employed) !== "0" &&
                            "-"}
                        </p>
                      </Grid>
                      {Number(candidateData?.is_employed) === 1 && (
                        <>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--text">
                              Type of Organisation
                            </p>
                          </Grid>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--subText">
                              {candidateData?.employee_organization_type
                                ? candidateData?.employee_organization_type
                                : "-"}
                            </p>
                          </Grid>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--text">
                              Date of Applying NOC
                            </p>
                          </Grid>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--subText">
                              {candidateData?.employee_organization_noc
                                ? fDate(
                                    candidateData?.employee_organization_noc,
                                    "dd/MM/yyyy"
                                  )
                                : "-"}
                            </p>
                          </Grid>
                        </>
                      )} */}
                      {/* <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--text">
                          Do you Want Relaxation in Measurement of Height and
                          Chest?
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--subText">
                          {Number(candidateData?.relaxation_in_measurement) ===
                          1
                            ? "Yes"
                            : "No"}
                        </p>
                      </Grid> */}
                      {/* <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--text">
                          Subject for Objective Exam Part-B
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--subText ">
                          {candidateData?.preferential_subject ? candidateData?.preferential_subject : "-"}
                        </p>
                      </Grid> */}
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--text">
                          Exam Centre Preference 1
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--subText">
                          {candidateData?.first_preference
                            ? candidateData?.first_preference
                            : "-"}
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--text">
                          Exam Centre Preference 2
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--subText">
                          {candidateData?.second_preference
                            ? candidateData?.second_preference
                            : "-"}
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--text">
                          Is there any criminal case pending against you?
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--subText">
                          {String(candidateData?.is_criminal) === "1" && "Yes"}
                          {String(candidateData?.is_criminal) === "0" && "No"}
                          {String(candidateData?.is_criminal) !== "1" &&
                            String(candidateData?.is_criminal) !== "0" &&
                            "-"}
                        </p>
                      </Grid>
                      {Number(candidateData?.is_criminal) === 1 && (
                        <>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--text">
                              Criminal Details
                            </p>
                          </Grid>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--subText">
                              {candidateData?.crime_details
                                ? candidateData?.crime_details
                                : "-"}
                            </p>
                          </Grid>
                        </>
                      )}
                      <Grid item lg={6} md={6} sm={6} xs={6} pr={6}>
                        <p className="candidate-info--text">
                          Whether debarred or Black Listed for Examination/
                          Selection held by UKPSC / UPSC / Other State Public
                          Service Commission?
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--subText">
                          {String(candidateData?.is_blacklist) === "1" && "Yes"}
                          {String(candidateData?.is_blacklist) === "0" && "No"}
                          {String(candidateData?.is_blacklist) !== "1" &&
                            String(candidateData?.is_blacklist) !== "0" &&
                            "-"}
                        </p>
                      </Grid>
                      {Number(candidateData?.is_blacklist) === 1 && (
                        <>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--text">
                              Blacklist From Date
                            </p>
                          </Grid>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--subText">
                              {candidateData?.blacklist_from_date
                                ? fDate(
                                  candidateData?.blacklist_from_date,
                                  "dd/MM/yyyy"
                                )
                                : "-"}
                            </p>
                          </Grid>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--text">
                              Blacklist To Date
                            </p>
                          </Grid>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--subText">
                              {candidateData?.blacklist_to_date
                                ? fDate(
                                  candidateData?.blacklist_to_date,
                                  "dd/MM/yyyy"
                                )
                                : "-"}
                            </p>
                          </Grid>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--text">
                              Blacklist Details
                            </p>
                          </Grid>
                          <Grid item lg={6} md={6} sm={6} xs={6}>
                            <p className="candidate-info--subText">
                              {candidateData?.blacklist_details
                                ? candidateData?.blacklist_details
                                : "-"}
                            </p>
                          </Grid>
                        </>
                      )}
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--text">
                          Candidate ID Proof
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--subText">
                          {candidateData?.id_proof
                            ? candidateData?.id_proof
                            : "-"}
                        </p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--text">ID Proof Number</p>
                      </Grid>
                      <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className="candidate-info--subText">
                          {candidateData?.id_proof_no
                            ? decrypt(candidateData?.id_proof_no)
                            : "-"}
                        </p>
                      </Grid>
                    </Grid>
                  </div>
                  <div className="print-view">
                    {/* <div className="print-details d-flex">
                      <div className="w-70">
                        <p className="candidate-info--text">
                          Are You Employed?
                        </p>
                      </div>
                      <div className="w-30">
                        <p className="candidate-info--subText">
                          {String(candidateData?.is_employed) === "1" && "Yes"}
                          {String(candidateData?.is_employed) === "0" && "No"}
                          {String(candidateData?.is_employed) !== "1" &&
                            String(candidateData?.is_employed) !== "0" &&
                            "-"}
                        </p>
                      </div>
                    </div>
                    {Number(candidateData?.is_employed) === 1 && (
                      <>
                        <div className="print-details d-flex">
                          <div className="w-70">
                            <p className="candidate-info--text">
                              Type of Organisation
                            </p>
                          </div>
                          <div className="w-30">
                            <p className="candidate-info--subText">
                              {candidateData?.employee_organization_type
                                ? decrypt(
                                    candidateData?.employee_organization_type
                                  )
                                : "-"}
                            </p>
                          </div>
                        </div>
                        <div className="print-details d-flex">
                          <div className="w-70">
                            <p className="candidate-info--text">
                              Date of Applying NOC
                            </p>
                          </div>
                          <div className="w-30">
                            <p className="candidate-info--subText">
                              {candidateData?.employee_organization_noc
                                ? fDate(
                                    candidateData?.employee_organization_noc,
                                    "dd/MM/yyyy"
                                  )
                                : "-"}
                            </p>
                          </div>
                        </div>
                      </>
                    )} */}
                    {/* <div className="print-details d-flex">
                      <div className="w-70">
                        <p className="candidate-info--text">
                          Do you Want Relaxation in Measurement of Height and
                          Chest?
                        </p>
                      </div>
                      <div className="w-30">
                        <p className="candidate-info--subText">
                          {Number(candidateData?.relaxation_in_measurement) ===
                          1
                            ? "Yes"
                            : "No"}
                        </p>
                      </div>
                    </div> */}
                    {/* <div className="print-details d-flex">
                      <div className="w-70">
                        <p className="candidate-info--text">
                          Subject for Objective Exam Part-B
                        </p>
                      </div>
                      <div className="w-30">
                        <p className="candidate-info--subText">
                          {candidateData?.preferential_subject ? candidateData?.preferential_subject : "-"}
                        </p>
                      </div>
                    </div> */}

                    <div className="print-details d-flex">
                      <div className="w-70">
                        <p className="candidate-info--text">
                          Exam Centre Preference 1
                        </p>
                      </div>
                      <div className="w-30">
                        <p className="candidate-info--subText">
                          {candidateData?.first_preference
                            ? candidateData?.first_preference
                            : "-"}
                        </p>
                      </div>
                    </div>
                    <div className="print-details d-flex">
                      <div className="w-70">
                        <p className="candidate-info--text">
                          Exam Centre Preference 2
                        </p>
                      </div>
                      <div className="w-30">
                        <p className="candidate-info--subText">
                          {candidateData?.second_preference
                            ? candidateData?.second_preference
                            : "-"}
                        </p>
                      </div>
                    </div>
                    <div className="print-details d-flex">
                      <div className="w-70">
                        <p className="candidate-info--text">
                          Is there any criminal case pending against you?
                        </p>
                      </div>
                      <div className="w-30">
                        <p className="candidate-info--subText">
                          {String(candidateData?.is_criminal) === "1" && "Yes"}
                          {String(candidateData?.is_criminal) === "0" && "No"}
                          {String(candidateData?.is_criminal) !== "1" &&
                            String(candidateData?.is_criminal) !== "0" &&
                            "-"}
                        </p>
                      </div>
                    </div>
                    {Number(candidateData?.is_criminal) === 1 && (
                      <div className="print-details d-flex">
                        <div className="w-70">
                          <p className="candidate-info--text">
                            Criminal Details
                          </p>
                        </div>
                        <div className="w-30">
                          <p className="candidate-info--subText">
                            {candidateData?.crime_details
                              ? candidateData?.crime_details
                              : "-"}
                          </p>
                        </div>
                      </div>
                    )}
                    <div className="print-details d-flex">
                      <div className="w-70">
                        <p className="candidate-info--text">
                          Whether debarred or Black Listed for Examination/
                          Selection held by UKPSC / UPSC / Other State Public
                          Service Commission?
                        </p>
                      </div>
                      <div className="w-30">
                        <p className="candidate-info--subText">
                          {String(candidateData?.is_blacklist) === "1" && "Yes"}
                          {String(candidateData?.is_blacklist) === "0" && "No"}
                          {String(candidateData?.is_blacklist) !== "1" &&
                            String(candidateData?.is_blacklist) !== "0" &&
                            "-"}
                        </p>
                      </div>
                    </div>
                    {Number(candidateData?.is_blacklist) === 1 && (
                      <>
                        <div className="print-details d-flex">
                          <div className="w-70">
                            <p className="candidate-info--text">
                              Blacklist From Date
                            </p>
                          </div>
                          <div className="w-30">
                            <p className="candidate-info--subText">
                              {candidateData?.blacklist_from_date
                                ? fDate(
                                  candidateData?.blacklist_from_date,
                                  "dd/MM/yyyy"
                                )
                                : "-"}
                            </p>
                          </div>
                        </div>
                        <div className="print-details d-flex">
                          <div className="w-70">
                            <p className="candidate-info--text">
                              Blacklist To Date
                            </p>
                          </div>
                          <div className="w-30">
                            <p className="candidate-info--subText">
                              {candidateData?.blacklist_to_date
                                ? fDate(
                                  candidateData?.blacklist_to_date,
                                  "dd/MM/yyyy"
                                )
                                : "-"}
                            </p>
                          </div>
                        </div>
                        <div className="print-details d-flex">
                          <div className="w-70">
                            <p className="candidate-info--text">
                              Blacklist Details
                            </p>
                          </div>
                          <div className="w-30">
                            <p className="candidate-info--subText">
                              {candidateData?.blacklist_details
                                ? candidateData?.blacklist_details
                                : "-"}
                            </p>
                          </div>
                        </div>
                      </>
                    )}
                    <div className="print-details d-flex">
                      <div className="w-70">
                        <p className="candidate-info--text">
                          Candidate ID Proof
                        </p>
                      </div>
                      <div className="w-30">
                        <p className="candidate-info--subText">
                          {candidateData?.id_proof
                            ? candidateData?.id_proof
                            : "-"}
                        </p>
                      </div>
                    </div>
                    <div className="print-details d-flex">
                      <div className="w-70">
                        <p className="candidate-info--text">ID Proof Number</p>
                      </div>
                      <div className="w-30">
                        <p className="candidate-info--subText">
                          {candidateData?.id_proof_no
                            ? decrypt(candidateData?.id_proof_no)
                            : "-"}
                        </p>
                      </div>
                    </div>
                  </div>
                </fieldset>
                <fieldset className="candidate-info--fieldset">
                  <legend className="candidate-info--legend">
                    Fee Details
                  </legend>
                  <div className="print-details d-flex">
                    <div className="w-70">
                      <p className="candidate-info--text">Application Fee</p>
                    </div>
                    <div className="w-30">
                      <p className="candidate-info--subText text-red">
                        Fee Exempted
                      </p>
                    </div>
                  </div>
                  {/* <Grid container spacing={1} className="print-display">
                    <Grid item lg={4} md={4} sm={4} xs={12}>
                      <div className="candidate-info--feeDetailBox">
                        <p>Bank Reference Number</p>
                        <span>
                          {!isFeeExempted
                            ? candidateData?.bank_ref_no
                              ? candidateData?.bank_ref_no
                              : "-"
                            : "NA"}
                        </span>
                      </div>
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={12}>
                      <div className="candidate-info--feeDetailBox custom-rht2">
                        <p>Transaction Date</p>
                        <span>
                          {!isFeeExempted
                            ? candidateData?.transaction_date
                              ? candidateData?.transaction_date
                              : "-"
                            : "NA"}
                        </span>
                      </div>
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={12}>
                      <div className="candidate-info--feeDetailBox custom-rht2">
                        <p>Application Fee</p>
                        <span>
                          &#8377;
                          {candidateData?.total_fee}
                        </span>
                      </div>
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={12}>
                      <div className="candidate-info--feeDetailBox custom-rht2">
                        <p>Processing Fee</p>
                        <span>
                          &#8377;{" "}
                          {Number(
                            candidateData?.permanent_resident_uttarakhand_covered_by_govt_order
                          ) === 1
                            ? "0"
                            : "22.30"}
                        </span>
                      </div>
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={12}>
                      <div className="candidate-info--feeDetailBox custom-rht2">
                        <p>Total Amount Payable</p>
                        <span>
                          &#8377;{" "}
                          {!isFeeExempted
                            ? (
                                candidateData?.total_fee +
                                (Number(
                                  candidateData?.permanent_resident_uttarakhand_covered_by_govt_order
                                ) === 1
                                  ? 0
                                  : 22.3)
                              ).toFixed(2)
                            : "0"}
                        </span>
                      </div>
                    </Grid>
                    <Grid item lg={4} md={4} sm={4} xs={12}>
                      <div className="candidate-info--feeDetailBox custom-rht2">
                        <p>Status</p>
                        <span
                          className={
                            candidateData?.payment_status
                              ? candidateData?.payment_status === "Success"
                                ? "text-green"
                                : "text-red"
                              : ""
                          }
                        >
                          {candidateData?.payment_status
                            ? isFeeExempted
                              ? "Fee Exempted"
                              : candidateData?.payment_status === "Success"
                              ? "Paid"
                              : "Failed"
                            : "-"}
                        </span>
                      </div>
                    </Grid>
                  </Grid> */}
                </fieldset>
                <fieldset className="candidate-info--fieldset">
                  <legend className="candidate-info--legend">
                    Declaration{" "}
                  </legend>
                  <Grid container spacing={1}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      {/* <Stack direction="row" alignItems="start"> */}
                      {/* <FormControlLabel
                            control={<Checkbox />}
                            name="declare_one"
                            value={declareValue?.first}
                            onChange={(e) => {
                              setDeclareValue((prev) => ({
                                ...prev,
                                first: !declareValue.first,
                              }));
                            }}
                            // label="I hereby declare that I have carefully read all the eligibility conditions mentioned in the advertisement and the above mentioned information in this application form. I accept and complete those requirements."
                            className="personal-information--checkbox"
                          />
                          <Stack direction="column" spacing={2}>
                            
                          </Stack>
                        </Stack> */}
                      <p className="candidate-info--subText custom-rht">
                        1.{" I "}
                        {candidateData?.name
                          ? decrypt(candidateData?.name)
                          : "-"}{" "}
                        hereby declare that I have carefully read all the
                        eligibility conditions mentioned in the advertisement
                        and the above mentioned information in this application
                        form. I accept and complete those requirements. <br />{" "}
                        एतद्द्वारा घोषणा करता हूं कि मैंने विज्ञापन में उल्लिखित
                        पात्रता की सभी शर्तों और इस आवेदन पत्र में दी गई उपरोक्त
                        जानकारी को सावधानीपूर्वक पढ़ लिया है। मैं उन आवश्यकताओं
                        को स्वीकार करता हूं और उन्हें पूरा करता हूं।
                      </p>
                      {/* {errors?.declare_one && touched?.declare_one && (
                            <p className="text-danger">{errors?.declare_one}</p>
                          )} */}
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      {/* <Stack direction="row" alignItems="start">
                          <FormControlLabel
                            control={<Checkbox />}
                            name="declare_two"
                            value={declareValue?.second}
                            onChange={(e) => {
                              setDeclareValue((prev) => ({
                                ...prev,
                                second: !declareValue.second,
                              }));
                            }}
                            // label="I hereby declare that I have carefully read all the eligibility conditions mentioned in the advertisement and the above mentioned information in this application form. I accept and complete those requirements."
                            className="personal-information--checkbox"
                          />
                          <Stack direction="column" spacing={2}>
                           
                          </Stack>
                        </Stack> */}
                      <p className="candidate-info--subText">
                        2.{" "}
                        {/* {candidateData?.name
                            ? decrypt(candidateData?.name)
                            : "-"}{" "} */}
                        I also declare that all the details / information given
                        in this application form is true and correct and I have
                        not hidden any facts in these particulars / information.
                        If any details / information is found to be false or
                        incorrect or if any facts are hidden by me, then my
                        candidature should be cancelled. If such situation comes
                        to light after the appointment, then my services should
                        be terminated. <br />
                        यह भी घोषणा करता हूं कि इस आवेदन पत्र में दिए गए सभी
                        विवरण/सूचनाएं सत्य और सही हैं और मैंने इन
                        विवरणों/जानकारी में कोई तथ्य नहीं छिपाया है। यदि मेरे
                        द्वारा कोई विवरण/सूचना असत्य या असत्य पायी जाती है या
                        कोई तथ्य छुपाया जाता है तो मेरी उम्मीदवारी रद्द कर दी
                        जाये। अगर नियुक्ति के बाद ऐसी स्थिति सामने आती है तो
                        मेरी सेवाएं समाप्त कर दी जानी चाहिए।
                      </p>
                    </Grid>
                    {Number(candidateData?.is_employed) === 1 &&
                      candidateData?.employee_organization_type !==
                      "Others" && (
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          {/* <Stack direction="row" alignItems="start">
                          <FormControlLabel
                            control={<Checkbox />}
                            name="declare_two"
                            value={declareValue?.second}
                            onChange={(e) => {
                              setDeclareValue((prev) => ({
                                ...prev,
                                second: !declareValue.second,
                              }));
                            }}
                            // label="I hereby declare that I have carefully read all the eligibility conditions mentioned in the advertisement and the above mentioned information in this application form. I accept and complete those requirements."
                            className="personal-information--checkbox"
                          />
                          <Stack direction="column" spacing={2}>
                           
                          </Stack>
                        </Stack> */}
                          <p className="candidate-info--subText">
                            3.{" "}
                            {/* {candidateData?.name
                              ? decrypt(candidateData?.name)
                              : "-"}{" "} */}
                            I am / am not a regular employee of State Government
                            / Government of India and I have informed the
                            competent authority about sending my application, on
                            (Date){" "}
                            {candidateData?.form_submitted_date
                              ? fDate(
                                candidateData?.form_submitted_date,
                                "dd/MM/yyyy"
                              )
                              : "-"}{" "}
                            for providing No Objection Certificate.
                            <br />
                            मैं राज्य सरकार/भारत सरकार का नियमित कर्मचारी हूँ/
                            नहीं हूँ और मैंने अपना आवेदन पत्र भेजने की सूचना
                            सक्षम प्राधिकारी को दिनांक{" "}
                            {candidateData?.form_submitted_date
                              ? fDate(
                                candidateData?.form_submitted_date,
                                "dd/MM/yyyy"
                              )
                              : "-"}{" "}
                            को विधिवत अनापत्ति प्रमाण पत्र प्रदान करने के लिए
                            प्रस्तुत कर दी है।
                          </p>
                        </Grid>
                      )}
                  </Grid>
                </fieldset>
                <div className="print-web">
                  <Stack
                    direction={{
                      lg: "row",
                      md: "row",
                      sm: "row",
                      xs: "column",
                    }}
                    justifyContent="space-between"
                    // className="textual"
                    mt={5}
                  >
                    <div className="candidate-info--textinfo">
                      {/* <div className="candidate-info--text">
                            <p>
                            Submitted Date: <span>06/02/2023</span>
                            </p>
                        </div> */}
                      <div className="candidate-info--text">
                        <p>
                          Place of filling form:{" "}
                          <span className="candidate-info--textspan">
                            {candidateData?.application_filling_place?.length >
                              0
                              ? candidateData?.application_filling_place
                              : "-"}
                          </span>
                        </p>
                      </div>
                      <div className="candidate-info--text">
                        <p>
                          Submitted Date & Time :{" "}
                          <span>
                            {/* {candidateData?.payment_status === "Success" &&
                              candidateData?.form_submitted_date
                              ? fDate(
                                candidateData?.form_submitted_date,
                                "dd/MM/yyyy hh:mm:ss"
                              )
                              : "-"} */}
                            {candidateData?.payment_status === "Success" &&
                              candidateData?.transaction_date
                              ? candidateData?.transaction_date
                              : "-"}

                          </span>
                        </p>
                      </div>
                      <div className="candidate-info--text">
                        <p>
                          Print Date :{" "}
                          <span>{fDate(new Date(), "dd/MM/yyyy")}</span>
                        </p>
                      </div>
                    </div>
                    <div className="candidate-info--signatureinfo">
                      <div className="candidate-info--signature">
                        <img
                          src={
                            candidateData?.candidate_signature
                              ? candidateData?.candidate_signature
                              : NoSignatureImg
                          }
                          alt="signature"
                          className="candidate-info--img"
                        />
                      </div>
                      <p className="candidate-info--signaturetext">
                        Signature of Candidate
                      </p>
                    </div>
                  </Stack>
                </div>
                <div className="print-view mt">
                  <div className="print-details d-flex j-btw border-0">
                    <div className="candidate-info--textinfo">
                      {/* <div className="candidate-info--text">
                            <p>
                            Submitted Date: <span>06/02/2023</span>
                            </p>
                        </div> */}
                      <div className="candidate-info--text">
                        <p>
                          Place of filling form:{" "}
                          <span className="candidate-info--textspan">
                            {candidateData?.application_filling_place?.length >
                              0
                              ? candidateData?.application_filling_place
                              : "-"}
                          </span>
                        </p>
                      </div>
                      <div className="candidate-info--text">
                        <p>
                          Submitted Date & Time :{" "}
                          <span>
                            {candidateData?.payment_status === "Success" &&
                              candidateData?.form_submitted_date
                              ? fDate(
                                candidateData?.form_submitted_date,
                                "dd/MM/yyyy hh:mm:ss"
                              )
                              : "-"}
                          </span>
                        </p>
                      </div>
                      <div className="candidate-info--text">
                        <p>
                          Print Date :{" "}
                          <span>{fDate(new Date(), "dd/MM/yyyy")}</span>
                        </p>
                      </div>
                    </div>
                    <div className="candidate-info--signatureinfo">
                      <div className="candidate-info--signature">
                        <img
                          src={
                            candidateData?.candidate_signature
                              ? candidateData?.candidate_signature
                              : NoSignatureImg
                          }
                          alt="signature"
                          className="candidate-info--img"
                        />
                      </div>
                      <p className="candidate-info--signaturetext">
                        Signature of Candidate
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Grid>
            {/* <div className="candidate-info--buttons">
                <div className="candidate-info--button1">
                  <Button variant="contained" onClick={handleBack}>
                    Back & Edit
                  </Button>
                </div>
                <div className="candidate-info--button2">
                  <Button
                    variant="contained"
                    onClick={() => {
                      handleState(1);
                    }}
                  >
                    Proceed
                  </Button>
                </div>
              </div> */}
          </Grid>
        )}
      </div>
    </Box>
  );
}
